import { WithdrawMethodWidget } from "./ui/withdraw_method.widget";

export default WithdrawMethodWidget;
